import React, { useState, useEffect } from "react";
import Header from "../../layout/header/header";
import Footer from "../../layout/footer/footer";
import sbanner from "../../assets/s-banner.png";
import simg1 from "../../assets/s-img1.png";
import simg2 from "../../assets/s-img2.png";
import timg from "../../assets/t-img.png";
import bimg from "../../assets/b-img.png";
import placeOr from "../../assets/place-or.png";
import noto from "../../assets/noto.png";
import i1 from "../../assets/i1.png";
import i2 from "../../assets/i2.png";
import h1 from "../../assets/h1.png";
import h2 from "../../assets/h2.png";
import acser from "../../assets/ac-ser.png";
import { Link, useParams } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import {
  arrayRemove,
  arrayUnion,
  collection,
  doc,
  getDoc,
  getDocs,
  increment,
  query,
  updateDoc,
  where,
} from "@firebase/firestore";
import { db } from "../../firebase";
import { useAuth } from "../../auth/useAuth";
import "../services/services.css";
import CartCheckout from "../checkout-cart/CartCheckout";

const Services = () => {
  let { service_id } = useParams();

  const { user } = useAuth();

  const [bookingModal, setBookingModal] = useState(false);
  const handleOpenBookingModal = () => setBookingModal(true);
  const handleCloseBookingModal = () => setBookingModal(false);

  const [loginModal, setLoginModal] = useState(false);
  const handleOpenLoginModal = () => setLoginModal(true);
  const handleCloseLoginModal = () => setLoginModal(false);

  const [subTypesModal, setSubTypesModal] = useState(false);
  const handleOpenSubTypesModal = () => setSubTypesModal(true);

  const [serviceId, setServiceId] = useState("");
  const [serviceData, setServiceData] = useState(null);
  const [subServiceData, setSubServiceData] = useState([]);
  const [subTypes, setSubTypes] = useState({});
  const [activeSubService, setActiveSubService] = useState(null);

  const [loadingSubServices, setLoadingSubServices] = useState(false);
  const [loadingSubTypes, setLoadingSubTypes] = useState(false);
  const [loadingCart, setLoadingCart] = useState(false);

  useEffect(() => {
    if (service_id) {
      setServiceId(service_id);
    } else {
      setServiceId("8kWlrwrEZprWCiqf9bYE");
    }
  }, [service_id]);

  useEffect(() => {
    if (serviceId) {
      fetchService(serviceId);
      fetchSubServices(serviceId);
    }
  }, [serviceId]);

  useEffect(() => {
    if (serviceId && subServiceData.length) {
      console.log("FETCHING_SUB_TYPES");
      fetchSubTypes(serviceId, subServiceData)
        .then((value) => {
          console.log("ALL SUB_TYPES:", value);
          setSubTypes(value);
        })
        .catch(() => console.log("ERROR WHILE FETCHING SUB_TYPES"));
    }
  }, [subServiceData]);

  const fetchService = async (serviceId) => {
    const docSnap = await getDoc(doc(db, "services", serviceId));
    if (docSnap.exists()) {
      console.log("SERIVCE DATA:", docSnap.data());
      setServiceData(docSnap.data());
    } else {
      console.log("No Service found!");
    }
  };

  const fetchSubServices = async (mServiceId) => {
    setLoadingSubServices(true);
    const q = query(
      collection(db, "sub_services"),
      where("service_id", "==", mServiceId)
    );
    const querySnapshot = await getDocs(q);
    let mSubServices = [];
    querySnapshot.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots
      mSubServices.push({ id: doc.id, ...doc.data() });
    });
    setSubServiceData(mSubServices);
    console.log("SUB_SERVICES:", mSubServices);
    setLoadingSubServices(false);
  };

  const getRateOfSubTypeForCity = (rateCardsArr) => {
    if (localStorage.getItem("selected_city")) {
      let cityId = JSON.parse(localStorage.getItem("selected_city")).id;
      let finalRateCards = rateCardsArr.filter((rateCard) => {
        return rateCard.city === cityId;
      });
      if (finalRateCards.length) {
        return finalRateCards[0].price;
      }
      return "NOSERVICE";
    } else {
      return "NOCITY";
    }
  };

  const fetchSubTypes = async (mServiceId, listOfSubServices) => {
    let allSubTypes = {};

    setLoadingSubTypes(true);
    for (let i = 0; i < listOfSubServices.length; i++) {
      const mSubService = listOfSubServices[i];
      const mSubServiceId = mSubService.id;
      const q = query(
        collection(db, "sub_types"),
        where("service_id", "==", mServiceId),
        where("sub_service_id", "==", mSubServiceId)
      );
      const querySnapshot = await getDocs(q);
      let currentSubTypes = [];
      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        currentSubTypes.push({
          id: doc.id,
          ...doc.data(),
        });
      });
      console.log("CURRENT SUB_TYPES:", currentSubTypes);
      allSubTypes[mSubServiceId] = currentSubTypes;
    }
    setLoadingSubTypes(false);
    return allSubTypes;
  };

  useEffect(() => {
    console.log("SUB_TYPES FINAL:", subTypes);
  }, [subTypes]);

  const getSelectedCity = () => {
    if (localStorage.getItem("selected_city")) {
      return JSON.parse(localStorage.getItem("selected_city")).name;
    }
    return "Mumbai";
  };

  const addItemToCart = async (mSubType, setLoading) => {
    setLoading(true);
    let price = getRateOfSubTypeForCity(mSubType.rate_card);
    if (price === "NOCITY") {
      return alert("Sorry, Please select city first!");
    }
    if (price === "NOSERVICE") {
      return alert(
        "Sorry, This service is not available in your city! Please change your city"
      );
    }

    // create clicked cart item
    const cartItem = {
      image: mSubType.icon,
      name: mSubType.name,
      price,
      service_id: mSubType.service_id,
      sub_service_id: mSubType.sub_service_id,
      sub_type_id: mSubType.id,
      vat: price * 0.05,
    };

    const userCartRef = doc(db, "users", user.uid);

    // push updated cart items to db
    try {
      await updateDoc(userCartRef, { cart: arrayUnion(cartItem) });
      // load latest cart items
      handleOpenSubTypesModal();
    } catch (error) {
      alert("Something went wrong! Please logout & login again!");
    } finally {
      setLoading(false);
    }
  };

  const ServiceCard = ({ mSubType }) => {
    const [mLoad, setMLoad] = useState(false);

    return (
      <div key={mSubType.id} className="col-md-4">
        {console.log("SUB_TYPE:", mSubType)}
        <div className="booking_product_inr">
          <div className="row align-items-center">
            <div className="col-sm-6">
              <img
                className="img-fluid"
                style={{
                  maxHeight: "100px",
                }}
                src={mSubType && mSubType.icon ? mSubType.icon : acser}
                alt=""
              />
            </div>
            <div className="col-sm-6 product_content pl-0">
              <h4>
                <span>
                  <i className="fa fa-star" aria-hidden="true"></i>{" "}
                  {mSubType && mSubType.rating ? mSubType.rating : "4.2"}
                </span>{" "}
                {mSubType && mSubType.number_of_ratings
                  ? `${mSubType.number_of_ratings} ratings`
                  : "23k ratings"}
              </h4>
              <div className="booking_price d-flex justify-content-between align-items-center">
                <h3>
                  {mSubType &&
                  mSubType.rate_card &&
                  mSubType.rate_card.length &&
                  typeof getRateOfSubTypeForCity(mSubType.rate_card) !==
                    "string"
                    ? "$ " + getRateOfSubTypeForCity(mSubType.rate_card)
                    : "Rate not available"}
                </h3>
                <button
                  type="button"
                  className="btn btn-primary"
                  // data-toggle="modal"
                  // data-target="#exampleModa2"
                  onClick={async () => {
                    await addItemToCart(mSubType, setMLoad);
                    handleOpenSubTypesModal();
                    handleCloseBookingModal();
                  }}
                >
                  {mLoad ? <div className="spinner-border"></div> : "ADD+"}
                </button>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 booking_split">
              <button className="btn">
                {mSubType && mSubType.name ? mSubType.name : "Name of SubType"}
              </button>
              <ul>
                <li>
                  {mSubType && mSubType.description
                    ? mSubType.description
                    : "Description of SubType"}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <Header />
      {/* <!-- banner start --> */}
      <section className="services_banner">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-lg-7 services_left">
              <h2>
                {serviceData && serviceData.name ? serviceData.name : ""} Expert
                in {getSelectedCity()}
              </h2>
              <ul className="banner_list">
                <li>30 days post-service guarantee</li>
                <li>Delivery at your convenience</li>
                <li>Insured work</li>
              </ul>
            </div>
            {!loadingSubServices ? (
              subServiceData.length ? (
                <div className="col-lg-5 services_right">
                  <div className="ac_expert">
                    <h4>
                      Need{" "}
                      {serviceData && serviceData.name ? serviceData.name : ""}{" "}
                      expert for:-
                    </h4>
                    {subServiceData.map((mSubService) => (
                      <div className="ac_expert_inr" key={mSubService.id}>
                        <h5>{mSubService.name}</h5>
                        <div className="book_now_btn">
                          <h6>
                            {" "}
                            <i
                              className="fa fa-star"
                              aria-hidden="true"
                            ></i>{" "}
                            {subTypes &&
                            subTypes[mSubService.id] &&
                            subTypes[mSubService.id].length &&
                            subTypes[mSubService.id][0].rating
                              ? subTypes[mSubService.id][0].rating
                              : "4.5"}
                            <span>
                              {subTypes &&
                              subTypes[mSubService.id] &&
                              subTypes[mSubService.id].length &&
                              subTypes[mSubService.id][0].number_of_ratings
                                ? `${
                                    subTypes[mSubService.id][0]
                                      .number_of_ratings
                                  } ratings`
                                : "23k ratings"}
                            </span>
                          </h6>
                          {/* <Link data-toggle="modal" data-target="#myModal">Book Now</Link> */}

                          <button
                            type="button"
                            className="btn btn-primary"
                            // data-toggle="modal"
                            // data-target={user ? "#exampleModal" : "#loginModal"}
                            onClick={() => {
                              console.log("SELECTED SUB_SERVICE:", mSubService);
                              if (user) {
                                setActiveSubService(mSubService.id);
                                handleOpenBookingModal();
                              } else handleOpenLoginModal();
                            }}
                          >
                            Book Now
                          </button>
                        </div>
                        <ul>
                          {subTypes &&
                          subTypes[mSubService.id] &&
                          subTypes[mSubService.id].length
                            ? subTypes[mSubService.id].map((mSubType) => (
                                <li key={mSubType.id}>
                                  {mSubType.description}
                                </li>
                              ))
                            : ""}
                        </ul>
                        <div className="split_ac_btn">
                          {subTypes &&
                          subTypes[mSubService.id] &&
                          subTypes[mSubService.id].length
                            ? subTypes[mSubService.id].map((mSubType) => (
                                <a href="#" key={mSubType.id}>
                                  {mSubType.name}
                                </a>
                              ))
                            : ""}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <div className="col-lg-5 services_right">
                  <div className="ac_expert">No sub-services found!</div>
                </div>
              )
            ) : (
              <div className="ac_expert">
                <div
                  className="row"
                  style={{
                    width: "100%",
                    justifyContent: "center",
                    margin: "1em 0px",
                  }}
                >
                  <div className="spinner-border"></div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
      {/* <!-- banner end -->

    <!-- services tabs --> */}
      <section className="services_tabs">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12 col-lg-8 col-xl-7">
              <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                <li className="nav-item" role="presentation">
                  <a className="nav-link" data-toggle="tab" href="#howwork">
                    How it works
                  </a>
                </li>
                <li className="nav-item" role="presentation">
                  <a className="nav-link" data-toggle="tab" href="#technicians">
                    Technicians
                  </a>
                </li>
                <li className="nav-item" role="presentation">
                  <a className="nav-link" data-toggle="tab" href="#FAQs">
                    FAQs
                  </a>
                </li>
                <li className="nav-item" role="presentation">
                  <a className="nav-link" data-toggle="tab" href="#acrepair">
                    About AC Repair
                  </a>
                </li>
                <li className="nav-item" role="presentation">
                  <a className="nav-link" data-toggle="tab" href="#blogs">
                    Blogs
                  </a>
                </li>
              </ul>
              <div className="tab-content" id="pills-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="howwork"
                  role="tabpanel"
                  aria-labelledby="pills-howwork-tab"
                >
                  <div className="tab_content">
                    <div className="inr_head">
                      <h2>How It Works</h2>
                    </div>
                    <div className="inr_body">
                      <div className="row">
                        <div className="col-3 text-center">
                          <img className="img-fluid" src={simg1} alt="s" />
                        </div>
                        <div className="col-9">
                          <h5>Chose Type of AC</h5>
                          <p>We service all types of ACs</p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-3 text-center">
                          <img className="img-fluid" src={simg1} alt="s" />
                        </div>
                        <div className="col-9">
                          <h5>Chose Type of AC</h5>
                          <p>We service all types of ACs</p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-3 text-center">
                          <img className="img-fluid" src={simg2} alt="s" />
                        </div>
                        <div className="col-9">
                          <h5>Chose Type of AC</h5>
                          <p>We service all types of ACs</p>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-3 text-center">
                          <img className="img-fluid" src={simg2} alt="s" />
                        </div>
                        <div className="col-9">
                          <h5>Chose Type of AC</h5>
                          <p>We service all types of ACs</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="technicians"
                  role="tabpanel"
                  aria-labelledby="pills-technicians-tab"
                >
                  <div className="tab_content techni_con">
                    <div className="inr_head">
                      <h2>Technicians</h2>
                    </div>
                    <div className="inr_body">
                      <div className="row">
                        <div className="col-3 text-center">
                          <img className="img-fluid" src={timg} alt="s" />
                        </div>
                        <div className="col-9">
                          <h5>Nitesh gupta</h5>
                          <p>
                            Very much experianced as well a profesional in ac
                            servicing
                          </p>
                          <h6>
                            <i className="fa fa-star" aria-hidden="true"></i>{" "}
                            4.8 Rating by more than 2138 customers
                          </h6>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-3 text-center">
                          <img className="img-fluid" src={timg} alt="s" />
                        </div>
                        <div className="col-9">
                          <h5>Nitesh gupta</h5>
                          <p>
                            Very much experianced as well a profesional in ac
                            servicing
                          </p>
                          <h6>
                            <i className="fa fa-star" aria-hidden="true"></i>{" "}
                            4.8 Rating by more than 2138 customers
                          </h6>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-3 text-center">
                          <img className="img-fluid" src={timg} alt="s" />
                        </div>
                        <div className="col-9">
                          <h5>Nitesh gupta</h5>
                          <p>
                            Very much experianced as well a profesional in ac
                            servicing
                          </p>
                          <h6>
                            <i className="fa fa-star" aria-hidden="true"></i>{" "}
                            4.8 Rating by more than 2138 customers
                          </h6>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-3 text-center">
                          <img className="img-fluid" src={timg} alt="s" />
                        </div>
                        <div className="col-9">
                          <h5>Nitesh gupta</h5>
                          <p>
                            Very much experianced as well a profesional in ac
                            servicing
                          </p>
                          <h6>
                            <i className="fa fa-star" aria-hidden="true"></i>{" "}
                            4.8 Rating by more than 2138 customers
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="FAQs"
                  role="tabpanel"
                  aria-labelledby="pills-faqs-tab"
                >
                  <div className="tab_content">
                    <div className="inr_head">
                      <h2>FAQs</h2>
                    </div>
                    <div className="inr_body">
                      <div className="accordion" id="accordionExample">
                        <div className="card">
                          <div className="card-header" id="headingOne">
                            <h2 className="mb-0">
                              <button
                                className="btn btn-link btn-block text-left"
                                type="button"
                                data-toggle="collapse"
                                data-target="#collapseOne"
                                aria-expanded="true"
                                aria-controls="collapseOne"
                              >
                                Collapsible Group Item #1
                              </button>
                            </h2>
                          </div>

                          <div
                            id="collapseOne"
                            className="collapse show"
                            aria-labelledby="headingOne"
                            data-parent="#accordionExample"
                          >
                            <div className="card-body">
                              Some placeholder content for the first accordion
                              panel. This panel is shown by default, thanks to
                              the <code>.show</code> className.
                            </div>
                          </div>
                        </div>
                        <div className="card">
                          <div className="card-header" id="headingTwo">
                            <h2 className="mb-0">
                              <button
                                className="btn btn-link btn-block text-left collapsed"
                                type="button"
                                data-toggle="collapse"
                                data-target="#collapseTwo"
                                aria-expanded="false"
                                aria-controls="collapseTwo"
                              >
                                Collapsible Group Item #2
                              </button>
                            </h2>
                          </div>
                          <div
                            id="collapseTwo"
                            className="collapse"
                            aria-labelledby="headingTwo"
                            data-parent="#accordionExample"
                          >
                            <div className="card-body">
                              Some placeholder content for the second accordion
                              panel. This panel is hidden by default.
                            </div>
                          </div>
                        </div>
                        <div className="card">
                          <div className="card-header" id="headingThree">
                            <h2 className="mb-0">
                              <button
                                className="btn btn-link btn-block text-left collapsed"
                                type="button"
                                data-toggle="collapse"
                                data-target="#collapseThree"
                                aria-expanded="false"
                                aria-controls="collapseThree"
                              >
                                Collapsible Group Item #3
                              </button>
                            </h2>
                          </div>
                          <div
                            id="collapseThree"
                            className="collapse"
                            aria-labelledby="headingThree"
                            data-parent="#accordionExample"
                          >
                            <div className="card-body">
                              And lastly, the placeholder content for the third
                              and final accordion panel. This panel is hidden by
                              default.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="acrepair"
                  role="tabpanel"
                  aria-labelledby="pills-aboutac-tab"
                >
                  <div className="tab_content">
                    <div className="inr_head">
                      <h2>All about AC Repair</h2>
                    </div>
                    <div className="inr_body">
                      <h4>3 Common problems in AC</h4>
                      <p>
                        The lorem ipsum gets its name from the Latin phrase
                        Neque porro quisquam est qui dolorem ipsum quia dolor
                        sit amet.hj ijcjm iiwcomx omocmomomcm nmcjnd The lorem
                        ipsum gets its name from the Latin phrase Neque porro
                        quisquam est qui dolorem ipsum quia dolor sit amet.hj
                        ijcjm iiwcomx omocmomomcm nmcjnd{" "}
                      </p>
                      <p>
                        1. The lorem ipsum : gets its name from the Latin phrase
                        Neque porro quisquam est qui dolorem ipsum quia dolor
                        sit amet.hj ijcjm iiwcomx omocmomomcm nmcjnd The lorem
                        ipsum gets its name from the Latin phrase Neque porro
                        quisquam est qui dolorem ipsum quia dolor sit amet.hj
                        ijcjm iiwcomx omocmomomcm nmcjnd{" "}
                      </p>
                      <p>
                        1. The lorem ipsum : gets its name from the Latin phrase
                        Neque porro quisquam est qui dolorem ipsum quia dolor
                        sit amet.hj ijcjm iiwcomx omocmomomcm nmcjnd The lorem
                        ipsum gets its name from the Latin phrase Neque porro
                        quisquam est qui dolorem ipsum quia dolor sit amet.hj
                        ijcjm iiwcomx omocmomomcm nmcjnd{" "}
                      </p>
                      <p>
                        1. The lorem ipsum : gets its name from the Latin phrase
                        Neque porro quisquam est qui dolorem ipsum quia dolor
                        sit amet.hj ijcjm iiwcomx omocmomomcm nmcjnd The lorem
                        ipsum gets its name from the Latin phrase Neque porro
                        quisquam est qui dolorem ipsum quia dolor sit amet.hj
                        ijcjm iiwcomx omocmomomcm nmcjnd{" "}
                      </p>
                      <p>
                        1. The lorem ipsum : gets its name from the Latin phrase
                        Neque porro quisquam est qui dolorem ipsum quia dolor
                        sit amet.hj ijcjm iiwcomx omocmomomcm nmcjnd The lorem
                        ipsum gets its name from the Latin phrase Neque porro
                        quisquam est qui dolorem ipsum quia dolor sit amet.hj
                        ijcjm iiwcomx omocmomomcm nmcjnd{" "}
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="blogs"
                  role="tabpanel"
                  aria-labelledby="pills-blogs-tab"
                >
                  <div className="tab_content">
                    <div className="inr_head">
                      <h2>Blogs</h2>
                    </div>
                    <div className="inr_body">
                      <div className="row">
                        <div className="col-md-4">
                          <div className="inr_body_col">
                            <img className="img-fluid" src={bimg} alt="" />
                            <h6>Know your Ac parts and spares </h6>
                            <p>9th June 2020</p>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="inr_body_col">
                            <img className="img-fluid" src={bimg} alt="" />
                            <h6>Know your Ac parts and spares </h6>
                            <p>9th June 2020</p>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="inr_body_col">
                            <img className="img-fluid" src={bimg} alt="" />
                            <h6>Know your Ac parts and spares </h6>
                            <p>9th June 2020</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- book highly --> */}
      <section className="book_highly">
        <div className="container-fluid">
          <div className="book_highly_inr">
            <div className="row">
              <div className="col-md-7">
                <h2>
                  Book Highly recommended
                  <br />
                  Professionals from our App
                </h2>
                <div className="book_img d-flex align-items-center mb-4">
                  <img className="img-fluid mr-3" src={i1} alt="img" />
                  <img className="img-fluid" src={i2} alt="img" />
                </div>
              </div>
              <div className="col-md-5 book_img_right d-flex">
                <img className="img-fluid mr-5" src={h1} alt="img" />
                <img className="img-fluid mt-3" src={h2} alt="img" />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- book highly --> */}
      <Footer />
      <div className="modal" id="myModal">
        <div className="modal-dialog">
          <div className="modal-content">
            {/* <!-- Modal Header --> */}
            <div className="modal-header">
              <h4 className="modal-title">Modal Heading</h4>
              <button type="button" className="close" data-dismiss="modal">
                &times;
              </button>
            </div>

            {/* <!-- Modal body --> */}
            <div className="modal-body">Modal body..</div>

            {/* <!-- Modal footer --> */}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Ist Login Model */}
      <Modal
        show={loginModal}
        onHide={handleCloseLoginModal}
        className="modal fade booking_popup"
        id="loginModal"
        tabIndex="-1"
        aria-labelledby="loginModalLabel"
        aria-hidden="true"
        centered
      >
        <div className="modal-dialog-centered">
          <div className="modal-content">
            <div className="p-4">Please Login to book a Service!</div>
          </div>
        </div>
      </Modal>
      {/* END Login Modal */}

      {/* Ist Booking Model */}
      <Modal
        show={bookingModal}
        size="lg"
        onHide={handleCloseBookingModal}
        className="booking_popup"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        centered
      >
        <div className="modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <div className="booking_btn">
                {subServiceData.length
                  ? subServiceData.map((mSubService) => (
                      <button
                        key={mSubService.id}
                        className={`btn ${
                          activeSubService === mSubService.id ? "active" : ""
                        }`}
                        onClick={() => setActiveSubService(mSubService.id)}
                      >
                        {mSubService.name}
                      </button>
                    ))
                  : ""}
              </div>
            </div>
            <div className="modal-body">
              <div className="booking_product_main">
                <div className="row">
                  <div className="col-12">
                    {/* is sub-type loaded or not */}
                    <h2>
                      {console.log(subTypes)}
                      {subTypes[activeSubService]
                        ? subServiceData.filter(
                            (mSubSer) => mSubSer.id === activeSubService
                          )[0].name
                        : ""}
                    </h2>
                    <div className="row">
                      {!loadingSubTypes ? (
                        subTypes[activeSubService] &&
                        subTypes[activeSubService].length ? (
                          subTypes[activeSubService].map((mSubType) => (
                            <ServiceCard mSubType={mSubType} />
                          ))
                        ) : (
                          <span className="p-5">
                            No SubTypes found for this SubService
                          </span>
                        )
                      ) : (
                        <div
                          className="row"
                          style={{
                            width: "100%",
                            justifyContent: "center",
                            margin: "1em 0px",
                          }}
                        >
                          <div className="spinner-border"></div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      {/* END Booking Modal */}

      {/* CART CHECKOUT */}
      <CartCheckout
        subTypesModal={subTypesModal}
        setSubTypesModal={setSubTypesModal}
      />

      {/* CHANGE LOCATION MODAL */}

      {/* <div className="modal fade apply_coupons_model" id="exampleModa11" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
                <div className="modal-body">
                    <div className="apply_coupons_main">
                        <button className="btn header_back_modal"><i className="fa fa-arrow-left" aria-hidden="true"></i>  CHANGE YOUR LOCATION</button>
                    </div>

                    <p data-toggle="modal" data-target="#exampleModa12">EMAAR Business Park, Bldg. 4, Office G-05 Sheikh Zayed Rd.</p>
                </div>
            </div>
        </div>
    </div> */}
      {/* YOUR  LOCATION MODAL */}
      {/* <div className="modal fade apply_coupons_model" id="exampleModa12" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
                <div className="modal-body">
                    <div className="apply_coupons_main">
                        <button className="btn header_back_modal"><i className="fa fa-arrow-left" aria-hidden="true"></i>  CONFIRM YOUR LOCATION</button>
                    </div>

                    <p data-toggle="modal" data-target="#exampleModa13">EMAAR Business Park, Bldg. 4, Office G-05 Sheikh Zayed Rd.</p>
                </div>
            </div>
        </div>
    </div> */}
      {/* YOUR  LOCATION MODAL */}
    </div>
  );
};

export default Services;
